import { TextField, InputAdornment } from '@mui/material'

export default function CustomTextField({
  label,
  disabled = false,
  readOnly = false,
  type = "text",
  multiline = false,
  rows = 1,
  error = false,
  helperText = "",
  shrink = true,
  endAdornment = null,
  variant = "outlined",
  size = "small",
  // value = "",
  ...field
}) {
  return (
      <TextField
      label={label}
      size={size}
      type={type}
      fullWidth
      multiline={multiline}
      rows={rows}
      {...field}
      error={error}
      helperText={helperText}
      variant={variant}
      slotProps={{
        inputLabel: {
          shrink: shrink
        }, 
        input: {
          readOnly: readOnly,
          endAdornment: 
          endAdornment && (
            <InputAdornment position="end">
              {endAdornment}
            </InputAdornment>
          )
          ,
        }}}
      disabled={disabled}
      onWheel={(event) => event.target.blur()}
      />
  )
}
